export const TENANT_CREATION_DEFAULTS = {
  active: true,
  live: false,
  aiSummaryEnabled: false,
  campaignEnabled: false,
  filtersEnabled: true,
  dateBasisEnabled: true,
  dateRangeEnabled: true,
  rolling12Enabled: true,
  planYTDVsPriorPlanYTDEnabled: true,
  planYTDVsPriorPlanYearEnabled: true,
  customRangeEnabled: true,
  divisionsEnabled: true,
  plansEnabled: true,
  cohortBuilderEnabled: true,
  phiCohortBuilderEnabled: false
};

export const getTenantCreationValues = (target) =>
  target?.id ? target : { ...TENANT_CREATION_DEFAULTS };
